import { render, staticRenderFns } from "./ReservationListLegacy.vue?vue&type=template&id=b2c80420&scoped=true"
import script from "./ReservationListLegacy.vue?vue&type=script&lang=js"
export * from "./ReservationListLegacy.vue?vue&type=script&lang=js"
import style0 from "./ReservationListLegacy.vue?vue&type=style&index=0&id=b2c80420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c80420",
  null
  
)

export default component.exports